export default defineNuxtRouteMiddleware(() => {});
